export default defineNuxtRouteMiddleware(() => {});
